
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import config from 'devextreme/core/config';

import { AppModule } from './app/app.module';
import { DEVEXTREME_LICENSE_KEY } from './devextreme-license-key';
import { environment } from './environments/environment';
import './polyfills';

config({ licenseKey: DEVEXTREME_LICENSE_KEY });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
